$(function(){

    

    $('#billboard')
    .before('<div id="billboardNav">')
    .cycle({
        fx: 'fade',
        speed: 1000,
        timeout: 6000,
        pager: '#billboardNav',
        pause: true,
        pauseOnPagerHover: true,
        slideExpr: '.slide',
        cleartype: true,
        cleartypeNoBg: true
    });
    
    

    $('.subFeaturesCollectionListing').jcarousel({
        buttonNextHTML: '<a href="#" onclick="return false;" id="next">Next</a>',
        buttonPrevHTML: '<a href="#" onclick="return false;" id="prev">Previous</a>'
    });

});